import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { Filter } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { FilterDetailsForm, FilterUsagesPage } from '.';

export function FilterPage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [filter, setFilter] = useState<Filter>();

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadFilter = useCallback(() => {
    apiClient
      .get(`filters/${id}`)
      .then((response: any) => {
        setFilter(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  const onFilterChanged = (filter: Filter) => {
    setFilter(filter);
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadFilter();
  }, [id, loadFilter]);

  const TabContent = (props: any) => {
    return <Content style={{ backgroundColor: '#fff' }}>{props.children}</Content>;
  };

  return (
    <>
      <PageHeader title="Filtre düzenle" subTitle={filter?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <FilterDetailsForm filter={filter} onSaved={onFilterChanged} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanımlar" key="usages">
            <TabContent>
              <Row>
                <Col span={16} xs={24} sm={24} md={24} lg={20} xl={20} xxl={16}>
                  <FilterUsagesPage filter={filter} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
